export default __webpack_public_path__ + "static/media/foto6.08d9b689.jpg";